import { useTranslation } from "react-i18next";

export default function TableOfContents() {
  const { t } = useTranslation("blog-isde");
  const items = t("toc.items", { returnObjects: true }) as string[];

  const anchors = [
    "#wat-is-isde",
    "#bedragen",
    "#voorwaarden",
    "#hoe-aanvragen",
    "#combineren",
    "#wij-helpen",
    "#faq",
  ];

  return (
    <nav className="bg-white border border-brand-border rounded-2xl p-5 md:p-6 mb-10 md:mb-14">
      <h3 className="font-geist font-bold text-base md:text-lg text-brand-text mb-3 md:mb-4">
        {t("toc.title")}
      </h3>
      <ol className="flex flex-col gap-2">
        {items.map((item, idx) => (
          <li key={idx}>
            <a
              href={anchors[idx]}
              className="font-geist text-sm text-brand-text/70 hover:text-brand-text transition-colors flex items-start gap-2"
            >
              <span className="font-geist-mono text-xs text-brand-text/40 w-5 flex-shrink-0 mt-0.5">
                {idx + 1}.
              </span>
              {item}
            </a>
          </li>
        ))}
      </ol>
    </nav>
  );
}